import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAuthUser } from 'auth/hooks';
import { PartFinderFamilyEditor } from 'companySettings/components';
import { canAccessPartFinderSetup } from 'companySettings/utils';
import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';

export const PartFinderFamilyPage = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const { user, isLoading } = useAuthUser();

  const title = t('titlePartFinderFamilies');

  if (isLoading) {
    return <PageLayout title={title} />;
  }

  if (!canAccessPartFinderSetup(user)) {
    return (
      <PageLayout title={title}>
        <Error statusCode={StatusCode.ACCESS_DENIED} />
      </PageLayout>
    );
  }

  return (
    <PageLayout title={title}>
      <PartFinderFamilyEditor familyId={Number(id)} />
    </PageLayout>
  );
};
